import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mentions, MENTIONS_TOC } from "@/components/legal/Mentions";
import { Privacy, PRIVACY_TOC } from "@/components/legal/Privacy";
import { Cgv, CGV_TOC } from "@/components/legal/Cgv";
import { LEGAL } from "@/content/legalInfo";

const PAGES = {
  mentions: { path: "/mentions-legales", title: "Mentions légales", C: Mentions, toc: MENTIONS_TOC },
  confidentialite: { path: "/confidentialite", title: "Politique de confidentialité", C: Privacy, toc: PRIVACY_TOC },
  cgv: { path: "/cgv", title: "CGV Premium", C: Cgv, toc: CGV_TOC },
};

export default function LegalPage({ page }) {
  const { title, C, toc } = PAGES[page];
  useEffect(() => window.scrollTo(0, 0), [page]);
  return (
    <div data-testid={`legal-page-${page}`} className="px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto py-12 sm:py-16">
      <nav data-testid="legal-tabs" className="flex flex-wrap gap-2 mb-10">
        {Object.entries(PAGES).map(([k, v]) => (
          <Link key={k} to={v.path} data-testid={`legal-tab-${k}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors ${k === page ? "bg-[#0B131E] text-white border-[#0B131E]" : "border-gray-300 text-gray-700 hover:border-amber-600"}`}>
            {v.title}
          </Link>
        ))}
      </nav>
      <div className="grid lg:grid-cols-[220px_1fr] gap-10">
        <aside className="hidden lg:block">
          <div className="sticky top-24">
            <p className="font-mono text-[11px] uppercase tracking-widest text-gray-400 mb-3">Sommaire</p>
            <ul className="space-y-2 text-sm">
              {toc.map(([id, l]) => <li key={id}><a href={`#${id}`} className="text-gray-600 hover:text-amber-700 transition-colors">{l}</a></li>)}
            </ul>
          </div>
        </aside>
        <article className="min-w-0 max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-widest text-amber-600">Informations légales</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl font-bold text-[#0B131E] leading-tight">{title}</h1>
          <p className="mt-4 text-sm text-gray-500">Dernière mise à jour : {LEGAL.updatedAt}. Wanderlust est une application proposée dans le cadre du studio {LEGAL.brand}.</p>
          <div className="legal mt-10"><C /></div>
        </article>
      </div>
    </div>
  );
}
